import React from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { SpinnerProps, SpinnerStylesStructure } from '@pijma/hero-types'
import { useStyles } from '@pijma/theme-provider'

export const Spinner = ({ size = 40, ...otherProps }: SpinnerProps) => {
  const props = { size, ...otherProps }

  const {
    components: { SpinnerIcon },
  } = useStyles<SpinnerStylesStructure>(['Spinner'], props)

  return (
    <PijmaComponent
      as="div"
      commonProps={props}
      style={{ display: 'inline-block' }}
    >
      {SpinnerIcon}
    </PijmaComponent>
  )
}

Spinner.displayName = 'Spinner'
